import { render, staticRenderFns } from "./TheNotification.vue?vue&type=template&id=1b6ae2fc&scoped=true&"
import script from "./TheNotification.vue?vue&type=script&lang=js&"
export * from "./TheNotification.vue?vue&type=script&lang=js&"
import style0 from "./TheNotification.vue?vue&type=style&index=0&id=1b6ae2fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6ae2fc",
  null
  
)

export default component.exports